/**
 * UnknownColumnMark — the warning glyph beside a DML column the written table
 * doesn't have (after Change table, or a typed name). Renders nothing while
 * the table's columns are unknown or the column is found.
 */

import { TriangleAlert } from 'lucide-react';

import { vqeCopy } from '../../ux/vqeCopy';
import { VqeTooltip } from '../common/VqeTooltip';
import { splitColumnRef } from '../../../../sql-resolver/scope/columnRefs';
import { findColumn, type WrittenTableColumns } from './assignmentColumns';

export function UnknownColumnMark({
  columnRef,
  table,
  testId,
}: {
  readonly columnRef: string;
  readonly table: WrittenTableColumns;
  readonly testId: string;
}) {
  if (!table.columns || !table.tableName || findColumn(table, columnRef)) return null;
  const text = vqeCopy.dmlColumns.unknownColumn(splitColumnRef(columnRef).name, table.tableName);
  // Focusable, so keyboard users reach the reason too.
  return (
    <VqeTooltip content={text}>
      <span role="img" tabIndex={0} aria-label={text} data-testid={testId} className="inline-flex shrink-0">
        <TriangleAlert aria-hidden className="h-3 w-3 text-warning" />
      </span>
    </VqeTooltip>
  );
}
